import image from "../assets/images/resource/featured-image-6.jpg";

const agencySection = {
  image,
  title: "Cutting-Edge Design\nsolutions",
  text: "",
  tabBtns: [
    {
      id: "tab-1",
      text: "Our Mission",
    },
    {
      id: "tab-2",
      text: "Our Vision",
    },
    {
      id: "tab-3",
      text: "Our History",
    },
  ],
  tabContents: [
    {
      id: "tab-1",
      text: "Transform your ideas into stunning, impactful designs and digital solutions. We strive to combine creativity with functionality, ensuring each project not only looks great but also performs exceptionally.",
    },
    {
      id: "tab-2",
      text: "A world where every brand, big or small, has access to top-tier design and digital solutions that elevate their presence and drive success. Our goal is to set new standards in design excellence and innovation.",
    },
    {
      id: "tab-3",
      text: "Founded with a passion for creativity and a commitment to quality, Rebix has grown from a small startup to a trusted partner for businesses around the globe. Our journey is marked by countless success stories and a portfolio that speaks for itself.",
    },
  ],
  textList: [
    "Expert Team",
    "Tailored Solutions",
    "Innovative Approach",
    "Proven Track Record",
  ],
};

export default agencySection;
